import { STATUS, MATCH_STATUS, JOB_STATUS } from "@/lib/constants";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, map = STATUS, vendorView = false, className, ...rest }) => {
  const s = map[status] || { label: status, cls: "bg-muted text-foreground" };
  return (
    <span data-testid={`status-badge-${status}`} className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-semibold whitespace-nowrap", s.cls, className)} {...rest}>
      {vendorView && s.vendor ? s.vendor : s.label}
    </span>
  );
};
export const MatchBadge = (p) => <StatusBadge map={MATCH_STATUS} {...p} />;
export const JobBadge = (p) => <StatusBadge map={JOB_STATUS} {...p} />;
